export const triggerHotjarPoll = (
  triggerName:
    | 'cm_feedback_poll'
    | 'cm_matched_qualities_poll'
    | 'cm_seekref_poll'
    | 'cm_shortlistbutton_pressed'
    | 'cm_rejectbutton_pressed'
    | 'cm_highfit_displayed'
    | 'cm_no_highfit_displayed',
) => {
  if (window.SEEK_TEST === true) {
    return;
  }
  if (typeof window.hj === 'function') {
    window.hj('trigger', triggerName);
  } else {
    /* eslint-disable-next-line no-console */
    console.warn(`Hotjar not available: tried to trigger ${triggerName}`);
  }
};

export const sendHotjarTag = (tagName: string | string[]) => {
  if (window.SEEK_TEST === true) {
    return;
  }
  if (typeof window.hj !== 'function' || !tagName) {
    return;
  }
  const tagsToSend = Array.isArray(tagName) ? tagName : [tagName];
  window.hj('tagRecording', tagsToSend);
};
